/// <amd-module name="TFS/Admin/Views/ProfileSettings/AboutView/Sources/AboutViewSource" />
import { getUserClient } from "TFS/Admin/Common/RestClient/User";
import { getProfileClient } from "TFS/Admin/Common/RestClient/Profile";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { getMarketingPreferencesClient } from "TFS/Admin/Common/RestClient/MarketingPreferences";
import { Avatar, UpdateUserParameters, User } from "TFS/Admin/Common/Contracts/User";
import { ProfileRegions } from "TFS/Admin/Common/Contracts/Profile";
import { IVssRestClientOptions } from "VSS/Platform/Context";
import { MarketingPreferences } from "TFS/Admin/Common/Contracts/MarketingPreferences";

export class AboutViewSource {
    private _options: IVssRestClientOptions = {};

    constructor(options: IVssRestClientOptions) {
        this._options = options;
    }

    public setMarketingPreferences(preferences: MarketingPreferences, descriptor: string, context: IVssComponentContext): Promise<void> {
        var restClient = this.getMarketingPreferencesClient(context);
        return restClient.setMarketingPreferences(preferences, descriptor);
    }

    public updateUser(userParameters: UpdateUserParameters, descriptor: string, context: IVssComponentContext): Promise<User> {
        var restClient = this.getUserClient(context);
        return restClient.updateUser(userParameters, descriptor);
    }

    public getRegions(context: IVssComponentContext): Promise<ProfileRegions> {
        var restClient = this.getProfileClient(context);
        return restClient.getRegions();
    }

    public deleteAvatar(descriptor: string, context: IVssComponentContext): Promise<void> {
        var restClient = this.getUserClient(context);
        return restClient.deleteAvatar(descriptor);
    }

    public setAvatar(avatar: Avatar, descriptor: string, context: IVssComponentContext): Promise<void> {
        var restClient = this.getUserClient(context);
        return restClient.setAvatar(avatar, descriptor);
    }

    public getUserClient(context: IVssComponentContext) {
        return getUserClient(context.pageContext, this._options);
    }

    public getMarketingPreferencesClient(context: IVssComponentContext) {
        return getMarketingPreferencesClient(context.pageContext, this._options);
    }

    public getProfileClient(context: IVssComponentContext) {
        return getProfileClient(context.pageContext, this._options);
    }
}
